import { gql } from 'apollo-angular';

export default gql`
  query GetPatientByOrderId($id: ID!) {
    getPatientByOrderId(id: $id) {
      id
      patient_number
      initials
      first_name
      middle_name
      last_name
      external_id
      street
      house_number
      postal_code
      city
      province
      country
      title
    }
  }

  query GetPatientById($id: ID!) {
    getPatientById(id: $id) {
      id
      patient_number
      initials
      first_name
      middle_name
      last_name
      date_of_birth
      gender
      id_type
      id_number
      bsn_number
      external_id
      health_insurer
      health_insurance_number
      street
      house_number
      postal_code
      city
      province
      country
      email
      phone
      mobile
      status
      notes
      referrer
      title
      tenant_ref
      tenant_id
    }
  }

  query GetPatientsCountByTenantId($tenant_id: ID!, $nextToken: String) {
    getPatientsCountByTenantId(tenant_id: $tenant_id, nextToken: $nextToken) {
      count
      nextToken
    }
  }

  query ListPatientsByTenantId($tenant_id: ID!) {
    listPatientsByTenantId(tenant_id: $tenant_id) {
      id
      patient_number
      external_id
      first_name
      middle_name
      last_name
      date_of_birth
      city
      mobile
      email
    }
  }

  query ListPatientsBySearchTerms($tenant_id: ID!, $search_terms: String, $limit: Int, $nextToken: String) {
    listPatientsBySearchTerms(
      tenant_id: $tenant_id
      search_terms: $search_terms
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        patient_number
        external_id
        first_name
        middle_name
        last_name
        date_of_birth
        city
        mobile
        email
      }
      nextToken
    }
  }

  mutation CreatePatient($input: CreatePatientInput!) {
    createPatient(input: $input) {
      id
    }
  }

  mutation UpdatePatient($input: UpdatePatientInput!) {
    updatePatient(input: $input) {
      id
    }
  }

  mutation AnonymizePatient($input: AnonymizePatientInput!) {
    anonymizePatient(input: $input) {
      id
    }
  }
`;
